import { SelfServiceUserAccount } from '@ekt-group/general-purpose-api-interfaces';

export function getAllowedContractIdsFromPermissions(
  permissions: SelfServiceUserAccount['permissions']
): number[] {
  const contractPermissions = permissions.find(({ action, subject }) => subject.toLowerCase() === 'contract' && action === 'manage')

  const contractIdCondition = contractPermissions?.conditions?.id;
  return contractIdCondition?.['$in'] || []
}
